import { GET_CURRENT_ACCESS_TOKEN_COOKIE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { logger } from '@dtx-company/logger'

export async function getCurrentAccessTokenCookie(): Promise<string | null> {
  try {
    const res = await fetch(GET_CURRENT_ACCESS_TOKEN_COOKIE_ENDPOINT, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      await logger.logFetchError(res, { technicalArea: 'authentication' })
    }
    const { accessToken } = (await res.json()) as { accessToken: string | null }
    return accessToken
  } catch (e: unknown) {
    logger.logError(e, { technicalArea: 'authentication' })
    return null
  }
}
